export default "__VITE_ASSET__g$zpVM$u__"